<div class="main">
<div class="section">
        <div class="header">
            <div class="title">
                <div class="titleLabel">{{'GANTT.title' | translate}}</div>
                <!-- <div class="help">
                  <app-help [helpData]="helpData" [helpTable]="helpTable"></app-help>
                </div> -->
              </div>


            <div class="input-container">
                <mat-form-field style="width:1px;visibility:hidden;">
                    <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" >
                    <mat-datepicker #picker  (closed)="redraw()"></mat-datepicker>
                  </mat-form-field>
                  <span class="material-icons" (click)="picker.open()">
                    today
                </span>
                <input (keyup)="applyFilter($event.target.value)" placeholder=""  class="inputSelect">
            </div>

            <div class="zoom">
                Zoom Level
                <div>
                    <div (click)="changeZoom(false)" class="button">-</div>
                    <div>{{ zoomLevel }}</div>
                    <div (click)="changeZoom(true)" class="button">+</div>
                </div>
            </div>
        </div>

        <ng-template #noShipments>
            <div class="noShipments">
              {{'GANTT.noShipments' | translate}}
            </div>
          </ng-template>


        <div class="ganttMain" *ngIf="shipmentsArray && shipmentsArray.length;else noShipments;">
            <div class="shipments">
                <div class="table">
                    <table mat-table  [dataSource]="shipmentsArray">
                        <ng-container matColumnDef="sNo">
                            <th mat-header-cell *matHeaderCellDef> {{'GANTT.sNo' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.sNo}} </td>
                        </ng-container>
                        <ng-container matColumnDef="est">
                            <th mat-header-cell *matHeaderCellDef> {{'GANTT.estDuration' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.est}} </td>
                        </ng-container>
                        <ng-container matColumnDef="actual">
                            <th mat-header-cell *matHeaderCellDef> {{'GANTT.actualDuration' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.actual}} </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef> {{'GANTT.status' | translate}} </th>
                            <td mat-cell *matCellDef="let element"> 
                                {{element.status}}
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="shipmentsColumns; sticky: true;"></tr>
                        <tr mat-row *matRowDef="let row; columns: shipmentsColumns;"></tr>
                    </table>
                </div>
                

            </div>
            <div class="ganttCanvas" >
                <div class="canvasSection">
                    <canvas #canvas></canvas>

                </div>

            </div>
        </div>



    </div>

</div>